import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import * as React from "react";
import { formatPaymentAmountDisplay } from "../../../services/common/convert";
import { colors, fontSizes } from "../../../theme";
import { DetailReportState } from "./store";

interface SideBarProps {
    heading: string;
    content: string;
    subTitle: string;
    displayColor: string;
}

const SideBarInfoSection: React.FC<SideBarProps> = (props: SideBarProps) => {
    return (
        <Box
            sx={{
                pt: 2,
                pb: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }}
        >
            <Box>
                <Typography variant="h6">{props.heading}</Typography>
            </Box>
            <Box
                sx={{
                    fontWeight: "bold",
                    fontSize: fontSizes.xlarge,
                }}
            >
                {props.content}

                <Box
                    sx={{
                        fontSize: fontSizes.normal,
                    }}
                >
                    {props.subTitle}
                </Box>
            </Box>
        </Box>
    );
};

interface Props {
    weeklydetail: DetailReportState;
}

export const SideInfoBar: React.FC<Props> = (props: Props) => {
    const shift_count = props.weeklydetail.detailHeaderInfo
        ? props.weeklydetail.detailHeaderInfo.shifts
        : 0;
    const avg_revenue = props.weeklydetail.detailHeaderInfo
        ? props.weeklydetail.detailHeaderInfo.avg_revenue
        : 0;
    const office_revenue = props.weeklydetail.detailHeaderInfo
        ? props.weeklydetail.detailHeaderInfo.office_avg_revenue
        : 0;

    return (
        <Box
            id="SideInfoBar-holder"
            sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "300px",
                pt: 33,
                height: "-webkit-fill-available",
            }}
        >
            <Box
                sx={{
                    backgroundColor: colors.white.main,
                    height: "100%",
                    borderRight: `1px solid ${colors.gray.a20}`,
                }}
            >
                <Box
                    sx={{
                        pb: 8,
                        pt: 8,
                        minWidth: "250px",
                        borderBottom: `1px solid ${colors.gray.a20}`,
                        ml: 8,
                        mr: 8,
                    }}
                >
                    <Box>
                        <Typography variant="h2">改善コメント</Typography>
                    </Box>
                    <Box
                        sx={{
                            pt: 4,
                        }}
                    >
                        <Typography variant="body1">
                            {props.weeklydetail.detailHeaderInfo?.comment}
                        </Typography>
                    </Box>
                </Box>
                <Box
                    sx={{
                        pt: 8,
                        pb: 8,
                    }}
                >
                    <Box
                        sx={{
                            p: 2,
                            pl: 8,
                            pr: 8,
                        }}
                    >
                        <SideBarInfoSection
                            heading={"期間乗務回数"}
                            content={`${shift_count}回`}
                            subTitle={""}
                            displayColor={""}
                        />
                        <SideBarInfoSection
                            heading={"平均営収"}
                            content={formatPaymentAmountDisplay(
                                avg_revenue,
                                true
                            )}
                            subTitle={""}
                            displayColor={""}
                        />
                        <SideBarInfoSection
                            heading={"営業所平均営収"}
                            content={formatPaymentAmountDisplay(
                                office_revenue,
                                true
                            )}
                            subTitle={""}
                            displayColor={""}
                        />
                        <Box
                            sx={{
                                pt: 6,
                                color: colors.black.main,
                                fontSize: fontSizes.small,
                            }}
                        >
                            ※　営収額は車載端末データからの概算値です
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};
